import { Link } from 'react-router-dom';

export function NotFoundPage({ kind = '404' }: { kind?: '403' | '404' }) {
  return (
    <main className="flex h-full flex-col items-center justify-center px-6 text-center">
      <p className="font-mono text-[12px] text-text-3">{kind}</p>
      <p className="mt-2 text-[20px] font-semibold text-text-1">
        {kind === '403' ? 'No access to this episode.' : 'Nothing here.'}
      </p>
      <p className="mt-2 max-w-md text-[14px] text-text-3">
        {kind === '403'
          ? 'Your account does not have access to that URL.'
          : 'Check the URL and try again.'}
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center rounded-md px-3 py-1.5 text-[12px] font-medium text-text-2 transition-colors hover:bg-surface-2 hover:text-text-1"
      >
        Go home
      </Link>
    </main>
  );
}
